import { render, staticRenderFns } from "./PermissionUpload.vue?vue&type=template&id=486b9dcc&scoped=true"
import script from "./PermissionUpload.vue?vue&type=script&lang=js"
export * from "./PermissionUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b9dcc",
  null
  
)

export default component.exports